import { render, staticRenderFns } from "./PolicySearch.vue?vue&type=template&id=13b3f5e6&scoped=true"
import script from "./PolicySearch.vue?vue&type=script&lang=js"
export * from "./PolicySearch.vue?vue&type=script&lang=js"
import style0 from "./PolicySearch.vue?vue&type=style&index=0&id=13b3f5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3f5e6",
  null
  
)

export default component.exports